"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initScript = exports.checkoutId = void 0;
exports.checkoutId = 'chargeafter-checkout-finance-sdk';
var initScript = function (envUrl, onLoaded) {
    var script = document.createElement('script');
    script.id = exports.checkoutId;
    script.onload = onLoaded;
    script.src = "".concat(envUrl, "?t=").concat(Date.now());
    script.async = true;
    document.body.appendChild(script);
};
exports.initScript = initScript;
